// extracted by mini-css-extract-plugin
export default {"updateMainFrame":"Update_updateMainFrame__Tguz3","submitButton":"Update_submitButton__7EhDC","warning":"Update_warning__90bFM"};